<template>
    <rkm-overlay>
        <rkm-layout-body title="Lista de tela">
            <template v-slot:actions>
                <rkm-button
                    @click="$router.push({ name: 'painel-senha-tela-create' })"
                    color="primary"
                    authorize="store-painel-senha-tela"
                >
                    Cadastrar tela
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/painel-senha/tela/List'

export default {
    components: { List },
}
</script>